import { getAuthToken } from '../apiClient';

// Match the rest of your app. BotPage.js already uses REACT_APP_API_BASE with this Render fallback.
const API_BASE =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  'https://mystockpicks.onrender.com';

function getToken() {
  return (
    getAuthToken?.() ||
    localStorage.getItem('token') ||
    localStorage.getItem('authToken') ||
    localStorage.getItem('auth_token') ||
    localStorage.getItem('accessToken') ||
    localStorage.getItem('jwt') ||
    sessionStorage.getItem('token') ||
    sessionStorage.getItem('authToken') ||
    sessionStorage.getItem('auth_token') ||
    sessionStorage.getItem('accessToken') ||
    sessionStorage.getItem('jwt') ||
    ''
  );
}

function decodeJwtPayload(token) {
  try {
    if (!token || token.split('.').length < 2) return {};
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch (e) {
    return {};
  }
}

function getUserIdentifier() {
  const payload = decodeJwtPayload(getToken());
  return String(payload.user_id || payload.id || payload.email || payload.sub || '').toLowerCase();
}

function withUser(path) {
  const userId = getUserIdentifier();
  if (!userId) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}user_id=${encodeURIComponent(userId)}`;
}

async function api(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };

  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${withUser(path)}`, { ...options, headers });
  const data = await res.json().catch(() => ({}));

  if (!res.ok || data.ok === false) {
    throw new Error(data.error || data.message || `Request failed: ${res.status}`);
  }

  return data;
}

export const cryptoApi = {
  getSettings: () => api('/api/crypto-bot/settings'),
  saveSettings: (payload) => api('/api/crypto-bot/settings', { method: 'POST', body: JSON.stringify(payload) }),
  runTick: (payload = { execute: true, ignore_enabled: true }) => api('/api/crypto-bot/run-tick', { method: 'POST', body: JSON.stringify(payload) }),
  top10: () => api('/api/crypto-bot/top10'),
  getUniverse: () => api('/api/crypto-bot/universe'),
  logs: (botType = '') => api(`/api/crypto-bot/logs${botType ? `?bot_type=${encodeURIComponent(botType)}` : ''}`),
  status: () => api('/api/crypto-bot/status'),
  saveRobinhood: (payload) => api('/api/crypto-bot/broker/robinhood', { method: 'POST', body: JSON.stringify(payload) }),

  getTargetSettings: () => api('/api/target-crypto/settings'),
  saveTargetSettings: (payload) => api('/api/target-crypto/settings', { method: 'POST', body: JSON.stringify(payload) }),
  runTargetTick: (payload = { execute: true, ignore_enabled: true }) => api('/api/target-crypto/run-tick', { method: 'POST', body: JSON.stringify(payload) }),
  runExits: (payload = { execute: true }) => api('/api/crypto-auto-exits/run', { method: 'POST', body: JSON.stringify(payload) }),
};
